// @mui
import { useTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';
// _mock
import {
  _ecommerceNewProducts,
  _ecommerceSalesOverview,
  _ecommerceBestSalesman,
  _ecommerceLatestProducts,
} from 'src/_mock';
// components
import { useSettingsContext } from 'src/components/settings';
// assets
import { MotivationIllustration } from 'src/assets/illustrations';
//
import EcommerceWelcome from '../ecommerce-welcome';
import EcommerceNewProducts from '../ecommerce-new-products';
import EcommerceYearlySales from '../ecommerce-yearly-sales';
import EcommerceBestSalesman from '../ecommerce-best-salesman';
import EcommerceSaleByGender from '../ecommerce-sale-by-gender';
import EcommerceSalesOverview from '../ecommerce-sales-overview';
import EcommerceWidgetSummary from '../ecommerce-widget-summary';
import EcommerceLatestProducts from '../ecommerce-latest-products';
import EcommerceCurrentBalance from '../ecommerce-current-balance';
import { useAuthContext } from 'src/auth/hooks';
import { Box, Card, CardContent, Typography } from '@mui/material';

// ----------------------------------------------------------------------

export default function OverviewEcommerceView() {
  const { user } = useAuthContext();
  console.log("🚀 ~ OverviewEcommerceView ~ user:", user)

  const theme = useTheme();

  const settings = useSettingsContext();

  return (


    <>


      <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
        <Box display="flex" justifyContent="start" width="100%">
          <Card
            sx={ {
              backgroundColor: '#FFFBEA',
              borderLeft: '4px solid #FFD700',
              borderRadius: '8px',
              boxShadow: 'none',
              padding: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              mt: 2,
              mb: 2,
            } }
          >
            {/* <InfoIcon sx={{ color: "#FFD700", fontSize: 22 }} /> */ }
            <CardContent sx={ { padding: '0px !important' } }>
              <Typography
                variant="body2"
                sx={ {
                  fontSize: '14px',
                  color: '#444',
                  lineHeight: 1.5,
                } }
              >
                <strong>Note:</strong> The Admin Dashboard is currently under construction. We will update it soon..
              </Typography>
            </CardContent>
          </Card>
        </Box>
        <Grid container spacing={ 3 }>
          <Grid xs={ 12 } md={ 8 }>
            <EcommerceWelcome
              title={ `Congratulations! \n ${user?.first_name} ${user?.last_name}` }
              description=""
              img={ <MotivationIllustration /> }
              action={
                <Button variant="contained" color="primary">
                  Go Now
                </Button>
              }
            />
          </Grid>

          <Grid xs={ 12 } md={ 6 } lg={ 4 }>
            <EcommerceSalesOverview title="Sales Overview" data={ _ecommerceSalesOverview } />
          </Grid>


          <Grid xs={ 12 } md={ 4 }>
            <EcommerceWidgetSummary
              title="Product Sold"
              percent={ 2.6 }
              total={ 0 }
              chart={ {
                series: [ 22, 8, 35, 50, 82, 84, 77, 12, 87, 43 ],
              } }
            />
          </Grid>

          <Grid xs={ 12 } md={ 4 }>
            <EcommerceWidgetSummary
              title="Total Balance"
              percent={ -0.1 }
              total={ 0 }
              chart={ {
                colors: [ theme.palette.info.light, theme.palette.info.main ],
                series: [ 56, 47, 40, 62, 73, 30, 23, 54, 67, 68 ],
              } }
            />
          </Grid>

          <Grid xs={ 12 } md={ 4 }>
            <EcommerceWidgetSummary
              title="Sales Profit"
              percent={ 0.6 }
              total={ 0 }
              chart={ {
                colors: [ theme.palette.warning.light, theme.palette.warning.main ],
                series: [ 40, 70, 75, 70, 50, 28, 7, 64, 38, 27 ],
              } }
            />
          </Grid>

          {/* <Grid xs={ 12 } md={ 6 } lg={ 4 }>
          <EcommerceSaleByGender
            title="Sale By Gender"
            total={ 2324 }
            chart={ {
              series: [
                { label: 'Mens', value: 44 },
                { label: 'Womens', value: 75 },
              ],
            } }
          />
        </Grid>

        <Grid xs={ 12 } md={ 6 } lg={ 8 }>
          <EcommerceYearlySales
            title="Yearly Sales"
            subheader="(+43%) than last year"
            chart={ {
              categories: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
              ],
              series: [
                {
                  year: '2019',
                  data: [
                    {
                      name: 'Total Income',
                      data: [ 10, 41, 35, 51, 49, 62, 69, 91, 148, 35, 51, 49 ],
                    },
                    {
                      name: 'Total Expenses',
                      data: [ 10, 34, 13, 56, 77, 88, 99, 77, 45, 13, 56, 77 ],
                    },
                  ],
                },
                {
                  year: '2020',
                  data: [
                    {
                      name: 'Total Income',
                      data: [ 51, 35, 41, 10, 91, 69, 62, 148, 91, 69, 62, 49 ],
                    },
                    {
                      name: 'Total Expenses',
                      data: [ 56, 13, 34, 10, 77, 99, 88, 45, 77, 99, 88, 77 ],
                    },
                  ],
                },
              ],
            } }
          />
        </Grid>

     
        <Grid xs={ 12 } md={ 6 } lg={ 4 }>
          <EcommerceCurrentBalance
            title="Current Balance"
            currentBalance={ 187650 }
            sentAmount={ 25500 }
          />
        </Grid>

        <Grid xs={ 12 } md={ 6 } lg={ 8 }>
          <EcommerceBestSalesman
            title="Best Salesman"
            tableData={ _ecommerceBestSalesman }
            tableLabels={ [
              { id: 'name', label: 'Seller' },
              { id: 'category', label: 'Product' },
              { id: 'country', label: 'Country', align: 'center' },
              { id: 'totalAmount', label: 'Total', align: 'right' },
              { id: 'rank', label: 'Rank', align: 'right' },
            ] }
          />
        </Grid>

        <Grid xs={ 12 } md={ 6 } lg={ 4 }>
          <EcommerceLatestProducts title="Latest Products" list={ _ecommerceLatestProducts } />
        </Grid> */}
        </Grid>
      </Container>
    </>
  );
}
